import React from 'react';
import PropTypes from 'prop-types';

import './statistical-summary.scss';

/*
  Component intended to introduce a standard display layout + styling for our
  pie chart + ancilary stats info stuff now used in more than one place. We want to keep
  the styling of the header / data columns consistent across these views.
*/
export default class StatisticalSummary extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    heading: PropTypes.string,
    actions: PropTypes.node,
    left: PropTypes.element,
    right: PropTypes.element
  };

  render() {
    const chartsAndStats = <div className='chart-and-stats-wrapper'>{this.props.children}</div>;

    const header =
      this.props.title || this.props.heading || this.props.actions ? (
        <div className='statistical-summary__header-wrapper'>
          <div className='statistical-summary__heading'>
            <h3 className='statistical-summary__heading-label'>{this.props.title}</h3>
            <div className='statistical-summary__heading-subject'>{this.props.heading}</div>
          </div>
          <div className='statistical-summary__header-actions'>{this.props.actions}</div>
        </div>
      ) : null;

    return (
      <div>
        {header}
        {chartsAndStats}
      </div>
    );
  }
}
